export default {
  updateErrors (state, data) {
    state.errors.member_name = data.errors.member_name ? data.errors.member_name[0] : null
    state.errors.member_id = data.errors.member_id ? data.errors.member_id[0] : null
    state.errors.code = data.errors.code ? data.errors.code[0] : null
  },

  clearErrors (state) {
    if (state.errors.code) {
      state.errors.code = null
    }

    if (state.errors.member_name) {
      state.errors.member_name = null
    }

    if (state.errors.member_id) {
      state.errors.member_id = null
    }
  },

  setDetails (state) {
    state.form.details.member_id = state.form.member_id
    state.form.details.member_name = state.form.member_name
  },

  updateField (state, {field, value}) {
    state.form[field] = value
  },

  applyVoucher (state, {voucher, discount, total}) {
    state.voucher = voucher
    state.discount = discount
    state.total = total
  },

  clearForm (state) {
    state.form.code = ''
    state.form.member_name = ''
    state.form.member_id = ''
    state.form.details.member_name = null
    state.form.details.member_id = null
  },

  removeVoucher (state, total) {
    state.voucher = null
    state.discount = null
    state.total = total
  }
}
